import React from 'react';
import { Collapse } from 'element-react';

function HelpAndSupportComponentBuyer({menu}) {
    const activeName = "0";
    const _className = menu ? {paddingLeft: '40px'} : {};
    return (
        <div style={_className}>
            <Collapse value={activeName} accordion>
                <Collapse.Item title="1. What is Bainub?" name="1">
                Bainub is a B2B industrial marketplace built to connect industrial buyers—including sourcing managers, procurement teams, and engineers—with specialized manufacturers and suppliers, to negotiate custom-made projects and build long-term supply partnerships.<br></br><br></br>
                The platform simplifies the procurement of industrial products and manufacturing services by enabling buyers to establish direct contact with manufacturers, making it easy to establish supply partnerships with companies in North America.
                </Collapse.Item>
                <Collapse.Item title="2. What kind of products can I find /source in Bainub?" name="2">
                Bainub is a B2B platform for components/products with special manufacturing characteristics, customized and, produced/packaged/labeled, according to the buyers requirement.<br></br><br></br>
                In Bainub you can find:
                <ul>
                    <li>Intermediate Components</li>
                    <li>Custom Manufacturing</li>
                    <li> White Label Products</li>
                    <li>Tools And Machinery</li>
                    <li>Packing And Packaging</li>
                    <li>Textile</li>
                    <li>Agriculture And Food</li>
                    <li>Molds and Tooling</li>
                    <li>Any product manufactured/produced for industry or wholesale market</li>
                </ul>
                </Collapse.Item>
                <Collapse.Item title="3. I can't find an specifc product, what do I do?" name="3">
                Didn’t find what you need? <a href="https://www.bainub.com/tools/rfq" target='_blank'>Submit your requirement</a> using the RFQ Direct tool in Bainub. We’ll share it with qualified suppliers in the right category so you can receive competitive proposals.
                </Collapse.Item>
                <Collapse.Item title="4. Do I have to pay any buying fees when making a transaction?" name="4">
                <p>Bainub won’t request any fee, commission, or participation as part of your trading operations.</p>
                </Collapse.Item>

                <Collapse.Item title="5. Is Bainub involved in my transactions?" name="5">
                <p>No, Bainub provides the platform to connect Buyers with manufacturers, then the traders can freely negotiate conditions and terms with each other for each of their transactions without us requiring any participation.
                You and your trade partner have full ownership and responsibility over the transaction.</p>
                </Collapse.Item>

                <Collapse.Item title="6. How to Get Started on Bainub?" name="6">
                <p>
                    Use our search engine to explore products or submit a request for quotation using the <a href="https://www.bainub.com/tools/rfq" target='_blank'>RFQ Direct tool.</a><br></br>
                    Once you find a supplier that meets your manufacturing needs, simply click Chat with Supplier to start a direct conversation.<br></br><br></br>

                    From there, you can easily share your project requirements, clarify technical details, and resolve any questions in real time.<br></br><br></br>

                    When you're ready to move forward, request a Purchasing Agreement.<br></br>
                    This shared document outlines all business terms and technical details. Review it, approve it, or suggest changes as needed.<br></br><br></br>

                    The Purchasing Agreement serves as a collaborative reference for both Buyer and Supplier throughout the project lifecycle.<br></br><br></br>

                    Let us know if you need any help!
                </p>
                </Collapse.Item>
            </Collapse>
           
            
        </div>
    );
}

export default HelpAndSupportComponentBuyer;
